<template>
    <div :class="['app-auth-page', 'reg-bg']">
        <div id="components-section" data-aos="fade-left">
            <div class="verify">
                <div style="text-align: center">
                    <img
                        style="width: 80px; height: 80px"
                        src="@/assets/images/mail.svg"
                        alt="email"
                    />
                </div>
                <div>
                    <span>
                        {{
                            $t(
                                "An email has been sent to you, Please verify your e-mail address by clicking the link sent to your email."
                            )
                        }}
                    </span>
                    <span>
                        {{ this.$store.state.userData.email }}
                    </span>
                </div>
                <div style="margin-top: 10px; color: tomato">
                    {{
                        $t(
                            "In the event that the email does not arrive, please check and check the junk mail - Junkbox"
                        )
                    }}
                </div>
                <div style="margin-top: 15px">
                    <p>
                        <span>
                            {{ $t("Do you need to change Email?") }}
                        </span>
                        <router-link to="/verify-data">{{
                            $t("Edit info")
                        }}</router-link>
                    </p>
                </div>

                <hr />
                <div style="text-align: center; margin-bottom: 40px">
                    <span
                        class="form-gray pseudo-button"
                        style="margin-top: 20px"
                        @click="resendEmailVerification"
                    >
                        {{ $t("Resend verification email") }}
                    </span>
                </div>
                <div style="display: flex; justify-content: center">
                    <Loading v-if="loading" />
                </div>
                <div
                    v-if="!loading"
                    style="
                        display: flex;
                        justify-content: space-between;
                        margin-top: 20px;
                    "
                >
                    <div>
                        <button
                            v-if="
                                $store.state.user &&
                                !$store.state.user.mobile_verified
                            "
                            class="auth-button"
                            @click="$router.push('/verify-mobile')"
                        >
                            {{ $t("Verify Mobile Number") }}
                        </button>
                    </div>
                    <button class="auth-button" @click="signOut">
                        {{ $t("Use another Account") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from "@/components/Loading";
export default {
    components: {
        Loading,
    },
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        signOut() {
            localStorage.removeItem("vuex");
            location.reload();
        },
        resendEmailVerification() {
            this.loading = true;
            this.$store
                .dispatch("RESEND_VERIFICAION_EMAIL")
                .then((res) => {
                    this.$buefy.toast.open({
                        message: this.$t(
                            "The link sent to your email, please check and verify."
                        ),
                        type: "is-primary",
                    });
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.form-gray {
    color: #818181;
}

.pseudo-button {
    position: relative;
    transition: 0.4s linear;
    margin-top: 50px;
    cursor: pointer;
    text-align: center;

    &::before {
        transition: 0.4s linear;
        position: absolute;
        content: "";
        display: inline-block;
        width: 100%;
        height: 1px;
        border-bottom: 1px solid #afa8f0;
        top: calc(100% + 5px);
        left: 0;
        transform-origin: center;
        transform: scaleX(0);
    }

    &:hover {
        color: #4c3cdd;

        &::before {
            transform: scaleX(1) !important;
        }
    }
}

.app-auth-page {
    // background: no-repeat 0 50%;
    // background-size: cover;
    min-width: 100vw;
    min-height: 100vh;
    padding: 10px 30px;

    @media screen and (max-width: 600px) {
        padding: 3px !important;
    }

    #components-section {
        display: flex;
        justify-content: center;
        width: 100%;
    }

    .verify {
        border-radius: 5px;
        margin: 10px 0;
        background-color: white;
        min-width: 500px;
        padding: 40px 50px;
        width: 500px;

        @media screen and (max-width: 600px) {
            min-width: 100%;
            width: 100%;
            padding: 40px 15px;
        }
    }
}
</style>
